import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http'
import { InjectionToken, NgModule } from '@angular/core'
import { Storage } from '@ionic/storage'

import { UserAuthProvider } from './user-auth'
import { UserAuthInterceptor } from './user-auth-interceptor'
import { UserAuthConfig } from './user-auth-models'


export function userAuthFactory(http: HttpClient, storage: Storage, config: UserAuthConfig) {
    return new UserAuthProvider(http, storage, config);
}


export const UserAuthConfigToken = new InjectionToken<UserAuthConfig>('UserAuthConfigToken');


@NgModule({
    declarations: [

    ],
    imports: [

    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UserAuthInterceptor,
            multi: true
        },
        {
            provide: UserAuthProvider,
            useFactory: userAuthFactory,
            deps: [HttpClient, Storage, UserAuthConfigToken]
        },

    ]

})
export class UserAuthModule {
    static init(config: UserAuthConfig) {
        // return UserAuthModule
        return {
            ngModule: UserAuthModule,
            providers: [
                { provide: UserAuthConfigToken, useValue: config }
            ]
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/mrk-user-auth/user-auth.module.ts